import { render } from "./Container.vue?vue&type=template&id=51b8a1ec&scoped=true"
import script from "./Container.vue?vue&type=script&lang=js"
export * from "./Container.vue?vue&type=script&lang=js"

import "./Container.vue?vue&type=style&index=0&id=51b8a1ec&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-51b8a1ec"

export default script